"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.LAZY_LOAD_DEFAULT_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=';
var THUMB_TYPE;
(function (THUMB_TYPE) {
    THUMB_TYPE["F_SM"] = "f160_160";
    THUMB_TYPE["F_MD"] = "f200_200";
    THUMB_TYPE["F_LG"] = "f240_240";
    THUMB_TYPE["F220_220"] = "f220_220";
    THUMB_TYPE["F200"] = "f200";
    THUMB_TYPE["NF750_380"] = "nf750_380";
    THUMB_TYPE["N320_320"] = "n320_320";
    THUMB_TYPE["F400_324"] = "f400_324";
    THUMB_TYPE["F202_260"] = "f202_260";
    THUMB_TYPE["FF500_500"] = "ff500_500";
    THUMB_TYPE["F65_65"] = "f65_65";
    THUMB_TYPE["F72_72"] = "f72_72";
    THUMB_TYPE["F80"] = "f80";
    THUMB_TYPE["F160"] = "f160";
    THUMB_TYPE["F164"] = "f164";
    THUMB_TYPE["F56"] = "f56";
    THUMB_TYPE["W304"] = "w304";
    THUMB_TYPE["W318"] = "w318";
    THUMB_TYPE["W320"] = "w320";
    THUMB_TYPE["W336"] = "w336";
    THUMB_TYPE["W345"] = "w345";
    THUMB_TYPE["W640"] = "w640";
    THUMB_TYPE["W720"] = "w720";
    THUMB_TYPE["W860"] = "w860";
    THUMB_TYPE["W2048"] = "w2048";
    THUMB_TYPE["M160"] = "m160";
    THUMB_TYPE["M290_290"] = "m290_290";
    THUMB_TYPE["M510"] = "m510";
    THUMB_TYPE["M960"] = "m960";
    THUMB_TYPE["M1280"] = "m1280";
    THUMB_TYPE["F40"] = "f40";
    THUMB_TYPE["F126_126"] = "f126_126";
    THUMB_TYPE["F212_212"] = "f212_212";
    THUMB_TYPE["F320"] = "f320";
    THUMB_TYPE["H180"] = "h180";
    THUMB_TYPE["H545"] = "h545";
    THUMB_TYPE["F120"] = "f120";
    THUMB_TYPE["F120_120"] = "f120_120";
    THUMB_TYPE["F170_170"] = "f170_170";
    THUMB_TYPE["F324_180"] = "f324_180";
    THUMB_TYPE["F750_1000"] = "f750_1000";
    THUMB_TYPE["F400_280"] = "f400_280";
    THUMB_TYPE["F100"] = "f100";
    THUMB_TYPE["F450"] = "f450";
    THUMB_TYPE["O640"] = "o640";
    THUMB_TYPE["F240"] = "f240";
    THUMB_TYPE["F260"] = "f260";
    THUMB_TYPE["F140"] = "f140";
    THUMB_TYPE["F266_149"] = "f266_149";
    THUMB_TYPE["M640"] = "m640";
    THUMB_TYPE["F602_602"] = "f602_602";
    THUMB_TYPE["M450"] = "m450";
    THUMB_TYPE["W480"] = "w480";
    THUMB_TYPE["F80_80"] = "f80_80";
    THUMB_TYPE["F480_390"] = "f480_390";
    THUMB_TYPE["F480_360"] = "f480x360";
    THUMB_TYPE["FFN225_225"] = "ffn225_225";
    THUMB_TYPE["FFN480_320"] = "ffn480_320";
    THUMB_TYPE["FFN450_450"] = "ffn450_450";
    THUMB_TYPE["F546_546"] = "f546_546";
    THUMB_TYPE["F133"] = "f133";
    THUMB_TYPE["F76_76"] = "f76_76";
    THUMB_TYPE["F344"] = "f344";
    THUMB_TYPE["F300"] = "f300";
    THUMB_TYPE["F300_300"] = "f300_300";
    THUMB_TYPE["FFN300_300"] = "ffn300_300";
    THUMB_TYPE["F244_162"] = "f244_162";
    THUMB_TYPE["F320_420"] = "f320_420";
    THUMB_TYPE["F396"] = "f396";
    THUMB_TYPE["W604"] = "w604";
    THUMB_TYPE["F130"] = "f130";
    THUMB_TYPE["F300_210"] = "f300_210";
    THUMB_TYPE["F296_390"] = "f296_390";
    THUMB_TYPE["F108_108"] = "f108_108";
    THUMB_TYPE["F290"] = "f290";
    THUMB_TYPE["F640"] = "f640";
})(THUMB_TYPE = exports.THUMB_TYPE || (exports.THUMB_TYPE = {}));
var THUMB_TYPE_SHOPPING;
(function (THUMB_TYPE_SHOPPING) {
    THUMB_TYPE_SHOPPING["F72"] = "f72";
    THUMB_TYPE_SHOPPING["M500"] = "m500";
    THUMB_TYPE_SHOPPING["W500"] = "w500";
})(THUMB_TYPE_SHOPPING = exports.THUMB_TYPE_SHOPPING || (exports.THUMB_TYPE_SHOPPING = {}));
var THUMB_TYPE_ANIGIF;
(function (THUMB_TYPE_ANIGIF) {
    THUMB_TYPE_ANIGIF["W336_REPEAT"] = "w336_repeat";
})(THUMB_TYPE_ANIGIF = exports.THUMB_TYPE_ANIGIF || (exports.THUMB_TYPE_ANIGIF = {}));
exports.replaceToHttps = function (source) {
    if (source && source.includes('http://')) {
        return source
            .replace(/http:\/\/(dthumb|post|shopping|dbscthumb).phinf.naver.net/gi, "https://$1-phinf.pstatic.net")
            .replace(/http:\/\/(shop1|shop2|bshop|cshop).phinf.naver.net/gi, "https://shop-phinf.pstatic.net")
            .replace(/http:\/\/img.shop.naver.net/gi, 'https://img-shop.pstatic.net')
            .replace(/http:\/\/static.shopping.naver.net/gi, 'https://ssl.pstatic.net/imgshopping')
            .replace(/http:\/\/checkout.phinf.naver.net/gi, 'https://phinf.pstatic.net/checkout.phinf')
            .replace(/http:\/\/checkout.naver.net/gi, 'https://ssl.pstatic.net/static.checkout')
            .replace(/http:\/\/image1.nmv.naver.net/gi, 'https://phinf.pstatic.net/image.nmv')
            .replace(/http:\/\/static-g.rmcnmv.naver.net/gi, 'https://sstatic-g.rmcnmv.naver.net ')
            .replace(/http:\/\/serviceapi.(nmv|rmcnmv).naver.com/gi, 'https://serviceapi.$1.naver.com')
            .replace(/http:\/\/(youtube.net|www.youtube.com)/gi, 'https://$1');
    }
    return source;
};
var noImage = process.env.PROJECT_NAME === 'mobile'
    ? 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/no_img.png'
    : 'https://ssl.pstatic.net/static.checkout/stylewindow/p/img/no_img.png';
var Img = /** @class */ (function (_super) {
    __extends(Img, _super);
    function Img(props) {
        var _this = _super.call(this, props) || this;
        _this.handleResize = function () {
            _this.setLazyLoadedImageStyle();
        };
        _this.setLazyLoadedImageStyle = function () {
            var imageratio = _this.props.imageratio;
            if (!imageratio)
                return;
            var height = _this.state.height;
            var imageParent = _this.ref && _this.ref.current.parentElement;
            var imageParentWidth = imageParent.offsetWidth;
            var newHeight = imageParentWidth * imageratio;
            if (height === newHeight)
                return;
            _this.setState({ height: imageParentWidth * imageratio });
        };
        _this.handleError = function (e) {
            e.target.src = _this.props.fallbackSrc;
        };
        _this.getThumbQuery = function (source, thumbType, isGifUsed) {
            if (isGifUsed === void 0) { isGifUsed = false; }
            if (isGifUsed) {
                var isGifType = /\.(gif)$/.test(source);
                return !isGifType && thumbType ? "?type=" + thumbType : '';
            }
            return thumbType ? "?type=" + thumbType : '';
        };
        _this.ref = React.createRef();
        _this.state = {
            height: 0,
        };
        return _this;
    }
    Img.prototype.componentDidMount = function () {
        this.props.setImageRef && this.props.setImageRef(this.ref);
        if (!this.props.isLazyLoaded) {
            return;
        }
        if (!this.props.lazyLoadOptions || !this.props.lazyLoadOptions.hasOwnProperty('root')) {
            this.setLazyLoadedImageStyle();
            this.lazyLoadImage();
        }
        this.props.imageratio && window.addEventListener('resize', this.handleResize);
    };
    Img.prototype.componentDidUpdate = function (prevProps) {
        if (!this.props.isLazyLoaded) {
            return;
        }
        // 상위 component 의 ref (this.props.lazyLoadOptions.root) 를 componentDidMount 시에는 알 수 없음
        // 하위 component 의 componentDidMount 호출 -> 상위 component 의 componentDidMount 호출되기 때문
        // 상위 component 에서 this.props.lazyLoadOptions.root 설정 시, 상위 component 에서 별도로 update 를 발생시켜야 함
        if (!this.observer && this.props.lazyLoadOptions && this.props.lazyLoadOptions.hasOwnProperty('root')) {
            this.setLazyLoadedImageStyle();
            this.lazyLoadImage();
        }
        else if (prevProps.src !== this.props.src) {
            this.observer && this.observer.unobserve(this.ref.current);
            this.setLazyLoadedImageStyle();
            this.lazyLoadImage();
        }
    };
    Img.prototype.componentWillUnmount = function () {
        this.observer && this.observer.unobserve(this.ref.current);
        window.removeEventListener('resize', this.handleResize);
    };
    Img.prototype.lazyLoadImage = function () {
        var isIe9 = window && window.__IS_IE9__;
        var isIe10 = window && window.__IS_IE10__;
        if (isIe9 || isIe10) {
            this.ref.current.setAttribute('src', this.ref.current.getAttribute('data-src'));
            return;
        }
        var lazyLoadOptions = __assign({}, this.props.lazyLoadOptions);
        if (!lazyLoadOptions.rootMargin) {
            lazyLoadOptions.rootMargin = window.innerHeight + "px 0px";
        }
        this.observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }
                var image = entry.target;
                image['src'] = image['dataset'].src;
                observer.unobserve(image);
            });
        }, this.props.lazyLoadOptions);
        this.observer.observe(this.ref.current);
    };
    Img.prototype.render = function () {
        var _a = this.props, src = _a.src, thumbType = _a.thumbType, fallbackSrc = _a.fallbackSrc, isGifUsed = _a.isGifUsed, isLazyLoaded = _a.isLazyLoaded, lazyLoadOptions = _a.lazyLoadOptions, setImageRef = _a.setImageRef, imageratio = _a.imageratio, restProps = __rest(_a, ["src", "thumbType", "fallbackSrc", "isGifUsed", "isLazyLoaded", "lazyLoadOptions", "setImageRef", "imageratio"]);
        var height = this.state.height;
        var imageSrc = exports.replaceToHttps(src) || fallbackSrc;
        var imageSrcWithThumbType = "" + imageSrc + this.getThumbQuery(imageSrc, thumbType, isGifUsed);
        return (React.createElement("img", __assign({ ref: this.ref, style: { height: height > 0 && height }, src: isLazyLoaded ? exports.LAZY_LOAD_DEFAULT_IMAGE : imageSrcWithThumbType, "data-src": imageSrcWithThumbType }, restProps, { onError: this.handleError })));
    };
    Img.defaultProps = {
        fallbackSrc: noImage,
        isLazyLoaded: false,
    };
    return Img;
}(React.Component));
exports.default = Img;
//# sourceMappingURL=index.js.map